<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="nav">
<h1 class="title">Contents</h1>
<ol>
<li class="tocfm" id="ncover"><a href="#/cover#cover">Cover</a></li>
<li class="tocfm" id="ntitle-page"><a href="#/title_page#title-page">Title Page</a></li>
<li class="tocfm" id="nde1"><a href="#/Dedication#de1">Dedication</a></li>
<li class="tocnav" hidden="hidden"><a href="#/nav">Contents</a></li>
<li class="tocbm" id="nch2"><a href="#/Chapter_1#ch2">Chapter 1</a></li>
<li class="tocbm" id="nch3"><a href="#/Chapter_2#ch3">Chapter 2</a></li>
<li class="tocbm" id="nch4"><span href="#/Chapter_3#ch4" title="Link target outside of Sample">Chapter 3</span></li>
<li class="tocbm" id="nch5"><span href="#/Chapter_4#ch5" title="Link target outside of Sample">Chapter 4</span></li>
<li class="tocbm" id="nch6"><span href="#/Chapter_5#ch6" title="Link target outside of Sample">Chapter 5</span></li>
<li class="tocbm" id="nch7"><span href="#/Chapter_6#ch7" title="Link target outside of Sample">Chapter 6</span></li>
<li class="tocbm" id="nch8"><span href="#/Chapter_7#ch8" title="Link target outside of Sample">Chapter 7</span></li>
<li class="tocbm" id="nch9"><span href="#/Chapter_8#ch9" title="Link target outside of Sample">Chapter 8</span></li>
<li class="tocbm" id="nch10"><span href="#/Chapter_9#ch10" title="Link target outside of Sample">Chapter 9</span></li>
<li class="tocbm" id="nch11"><span href="#/Chapter_10#ch11" title="Link target outside of Sample">Chapter 10</span></li>
<li class="tocbm" id="nch12"><span href="#/Chapter_11#ch12" title="Link target outside of Sample">Chapter 11</span></li>
<li class="tocbm" id="nch13"><span href="#/Chapter_12#ch13" title="Link target outside of Sample">Chapter 12</span></li>
<li class="tocbm" id="nch14"><span href="#/Chapter_13#ch14" title="Link target outside of Sample">Chapter 13</span></li>
<li class="tocbm" id="nch15"><span href="#/Chapter_14#ch15" title="Link target outside of Sample">Chapter 14</span></li>
<li class="tocbm" id="nch16"><span href="#/Chapter_15#ch16" title="Link target outside of Sample">Chapter 15</span></li>
<li class="tocbm" id="nep17"><span href="#/Epilogue#ep17" title="Link target outside of Sample">Epilogue</span></li>
<li class="tocrm" id="ndi18"><span href="#/Discussion_Questions#di18" title="Link target outside of Sample">Discussion Questions</span></li>
<li class="tocrm" id="nac19"><span href="#/Acknowledgments#ac19" title="Link target outside of Sample">Acknowledgments</span></li>
<li class="tocrm" id="ngl20"><span href="#/Glossary#gl20" title="Link target outside of Sample">Glossary</span></li>
<li class="tocrm" id="nab21"><span href="#/About_the_Author#ab21" title="Link target outside of Sample">About the Author</span></li>
<li class="tocrm" id="nen23"><span href="#/Endorsements#en23" title="Link target outside of Sample">Acclaim for Kathleen Fuller</span></li>
<li class="tocrm" id="nca24"><span href="#/Card_Page#ca24" title="Link target outside of Sample">Other Books by Kathleen Fuller</span></li>
<li class="tocrm" id="ne-25"><a href="#/ECopyright#e-25">Copyright</a></li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?604d53d6